import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PromotionApprovalReducer } from '../reducers';

export const selectPromotionApprovalFeature = createFeatureSelector<PromotionApprovalReducer.PromotionApprovalState>(PromotionApprovalReducer.featureName);

export const selectPromotionApproval = createSelector(selectPromotionApprovalFeature, (state: PromotionApprovalReducer.PromotionApprovalState) => state.item);
